import { RECEIVE_ORIGIN_PORTS, RECEIVE_DESTINATION_PORTS, SET_SELECTED_ARRIVAL_PORT, SET_SELECTED_ORIGIN_PORT } from './actionTypes';

import portRemote from '../../api/portRemote';

import Ports from '../../models/Ports';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { receiveError } from './notificationAction';

function destinationPortsSuccess(resp: Ports) {
  return {
    type: RECEIVE_DESTINATION_PORTS,
    data: resp
  }
};

function originPortsSuccess(resp: Ports) {
  return {
    type: RECEIVE_ORIGIN_PORTS,
    data: resp
  }
};

function receivePorts(direction: 'org' | 'dst') {

  return (dispatch: any) => {

    portRemote.getPorts(direction).then((resp: ApiResponse<Ports>) => {

      const ports: Ports | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (ports && direction === 'dst') {
        dispatch(destinationPortsSuccess(ports));
      } 
      
      if (ports && direction === 'org') {
        dispatch(originPortsSuccess(ports));
      } 

      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
};

function setDestinationPort(port: string) {

  return {
    type: SET_SELECTED_ARRIVAL_PORT,
    data: port
  };
};

function setOriginPort(port: string) {

  return {
    type: SET_SELECTED_ORIGIN_PORT,
    data: port
  };
};

 export {
   receivePorts,
   setDestinationPort,
   setOriginPort
 }
